import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

// 言語jsonファイルのimport
import translation_ja from './ja.json';

export const Reporti18nInstance = createInstance();

const defaultNS = 'report';
export const reportResources = {
  ja: {
    report: translation_ja,
  },
};

export const reportNs = ['report'];

void Reporti18nInstance.use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: 'ja',
    ns: reportNs,
    defaultNS,
    resources: reportResources,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
